import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CATEGORIES, FontAwesomeIcon } from "../../font-awesome-icon/src";
import { __ } from "../../i18n/src";
import { ScreenReadersContent } from "../../screen-readers-content/src";
import { Dropdown } from './Dropdown';
export const DropdownThreeDotsIcon = (_a) => {
    var { screenReadersText = __('Open dropdown') } = _a, props = __rest(_a, ["screenReadersText"]);
    return (_jsxs(Dropdown, Object.assign({}, props, { children: [_jsx(ScreenReadersContent, { children: screenReadersText }), _jsx(FontAwesomeIcon, { height: "18px", iconName: "ellipsis", iconType: CATEGORIES.SOLID })] })));
};
//# sourceMappingURL=DropdownThreeDotsIcon.js.map